<template>
    <div class="chart-container">
        <div class="primary-value">
            <div class="lga-value lg">
                {{ model.format(model.value) }}<span class="lga-units">{{ model.valueUnits }}</span>
            </div>
            <div class="label">
                <div class="inline-block">
                    {{ model.label }}
                </div>
            </div>
        </div>
        <dynamic-resize-container class="dot-plot">
            <template
                #default="{width}"
            >
                <dot-plot
                    v-if="width > 0"
                    :width="width"
                    :height="20"
                    :value="model.value"
                    :compare-value="model.comparisonValue"
                    :domain="model.domain"
                >
                    <template
                        #tooltip-content="{ type }"
                    >
                        <div>
                            <div class="tooltip-label">
                                {{ model.valueLabel }}
                            </div>
                            <div :class="`tooltip-value ${type === 'value' ? 'highlight' : ''}`">
                                {{ model.formatWithUnits(model.value) }}
                            </div>
                            <div class="tooltip-compare-value">
                                <span :class="`${type === 'compare' ? 'highlight' : ''}`">{{ model.formatWithUnits(model.comparisonValue) }}</span> in {{ model.comparisonLabel }}
                            </div>
                        </div>
                    </template>
                    <template
                        #label-content
                    >
                        <tspan
                            v-if="model.comparisonValue === null || model.comparisonValue === undefined"
                            class="compare-label right"
                            dy="0.5em"
                        >
                            {{ model.comparisonLabel }} data unavailable
                        </tspan>
                        <tspan
                            v-else-if="model.value > model.comparisonValue"
                            class="compare-label left"
                            dy="0.5em"
                        >
                            {{ model.formatWithUnits(model.comparisonValue) }} in {{ model.comparisonLabel }}
                        </tspan>
                        <tspan
                            v-else
                            class="compare-label right"
                            dy="0.5em"
                        >
                            {{ model.formatWithUnits(model.comparisonValue) }} in {{ model.comparisonLabel }}
                        </tspan>
                    </template>
                </dot-plot>
            </template>
        </dynamic-resize-container>

        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import DotPlot from '@/components/DotPlot.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        DynamicResizeContainer, DotPlot, InfoTooltip
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
div.bc-container {
    @apply flex flex-col items-center;
}

div.primary-value {
    @apply flex flex-row items-baseline;
}

.lga-value {
    @apply mr-2;
}
</style>
